import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["finishedSection", "finishForm"]

  showFinishForm() {
    this.finishedSectionTarget.classList.add("d-none")
    this.finishFormTarget.classList.remove("d-none")
  }

  hideFinishForm() {
    this.finishFormTarget.classList.add("d-none")
    this.finishedSectionTarget.classList.remove("d-none")
  }
}
